module.exports = __webpack_public_path__ + "img/kf.e7680093.png";